"use strict";
exports.__esModule = true;
exports.ElevatedIconButton = exports.IconButton = void 0;
var tslib_1 = require("tslib");
var core_1 = require("@material-ui/core");
var react_1 = tslib_1.__importStar(require("react"));
var ClassPrefixContext_1 = require("../context/ClassPrefixContext");
var useIconButtonClasses = function (classPrefix) {
    return core_1.makeStyles(function (theme) {
        var _a, _b, _c, _d;
        var _e, _f, _g, _h, _j, _k, _l;
        return core_1.createStyles({
            root: (_a = {
                    width: 35,
                    height: 35
                },
                _a["& ." + classPrefix + "MuiIcon-root"] = {
                    fontSize: '1.4rem',
                    color: (_e = theme.palette) === null || _e === void 0 ? void 0 : _e.secondary.main
                },
                _a['&:disabled'] = (_b = {},
                    _b["& ." + classPrefix + "MuiIcon-root"] = {
                        color: (_f = theme.palette) === null || _f === void 0 ? void 0 : _f.grey[100]
                    },
                    _b),
                _a['&:hover'] = {
                    backgroundColor: 'rgba(23, 43, 77, 0.04)'
                },
                _a),
            sizeSmall: (_c = {
                    width: 24,
                    height: 24
                },
                _c["& ." + classPrefix + "MuiIcon-root"] = {
                    fontSize: '1rem'
                },
                _c),
            colorPrimary: (_d = {
                    border: "1px solid " + ((_g = theme.palette) === null || _g === void 0 ? void 0 : _g.primary.main),
                    backgroundColor: "" + ((_h = theme.palette) === null || _h === void 0 ? void 0 : _h.primary.main)
                },
                _d["& ." + classPrefix + "MuiIcon-root"] = {
                    color: 'white'
                },
                _d['&:hover'] = {
                    backgroundColor: 'rgb(2, 139, 206)',
                    borderColor: 'rgb(2, 139, 206)'
                },
                _d['&:disabled'] = {
                    backgroundColor: (_j = theme.palette) === null || _j === void 0 ? void 0 : _j.grey[40],
                    borderColor: (_k = theme.palette) === null || _k === void 0 ? void 0 : _k.grey[40]
                },
                _d),
            colorSecondary: {
                border: "1px solid " + ((_l = theme.palette) === null || _l === void 0 ? void 0 : _l.grey[70]),
                '&:hover': {
                    backgroundColor: 'rgba(23, 43, 77, 0.04)'
                }
            }
        });
    });
};
var StyledIconButton = function (props) {
    var children = props.children, rest = tslib_1.__rest(props, ["children"]);
    var classPrefix = react_1.useContext(ClassPrefixContext_1.ClassPrefixContext);
    var classes = useIconButtonClasses(classPrefix)();
    return (react_1["default"].createElement(core_1.IconButton, tslib_1.__assign({ classes: tslib_1.__assign(tslib_1.__assign({}, classes), props.classes) }, rest), children));
};
exports.IconButton = StyledIconButton;
var useStyles = core_1.makeStyles(function (theme) {
    return core_1.createStyles({
        buttonStyle: function (_a) {
            var variant = _a.variant;
            return ({
                borderRadius: variant === 'circle'
                    ? '50%'
                    : variant === 'square'
                        ? 0
                        : theme.shape.borderRadius,
                padding: 4,
                justifyContent: 'center',
                display: 'inline-flex',
                cursor: 'pointer'
            });
        }
    });
});
function ElevatedIconButton(props) {
    var _a = props.variant, variant = _a === void 0 ? 'circle' : _a, children = props.children, rest = tslib_1.__rest(props, ["variant", "children"]);
    var classes = useStyles(props);
    return (react_1["default"].createElement(core_1.ButtonBase, null,
        react_1["default"].createElement(core_1.Paper, tslib_1.__assign({ className: classes.buttonStyle }, rest), children)));
}
exports.ElevatedIconButton = ElevatedIconButton;
//# sourceMappingURL=IconButton.js.map